module.exports = __webpack_public_path__ + "img/youtube_w.d3ea5b90.svg";